import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { acceptCustomerInvitation } from '../thunks/customers';
import { removeCustomerMember } from '../thunks/users';

const rolesAdapter = createEntityAdapter({});

export const rolesSlice = createSlice({
  name: 'roles',
  initialState: rolesAdapter.getInitialState({}),
  reducers: {
    setRoles: (state, action) => {
      rolesAdapter.setAll(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(acceptCustomerInvitation.fulfilled, (state, action) => {
      const { userRoles } = action.payload;
      rolesAdapter.upsertMany(state, userRoles);
    });
    builder.addCase(removeCustomerMember.fulfilled, (state, action) => {
      const { customerId } = action.meta.arg;
      const { removedUserId, currentUserId } = action.payload;

      // The roles slice holds only the logged-in user's roles. Only drop the
      // caller's own customer role when they removed themselves; removing
      // another member must not touch the caller's roles.
      if (removedUserId !== currentUserId) return;

      const removedMemberRoleId = state.ids.find(
        (roleId) => state.entities[roleId].customer?.id === customerId
      );

      if (removedMemberRoleId)
        rolesAdapter.removeOne(state, removedMemberRoleId);
    });
  },
});

export const { setRoles } = rolesSlice.actions;

export const rolesAdapterSelectors = rolesAdapter.getSelectors(
  (state) => state.roles
);

export default rolesSlice.reducer;
